import React from 'react';

export const LockIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g
                fillOpacity="1"
                strokeDasharray="none"
                strokeMiterlimit="4"
                strokeOpacity="1"
            >
                <path
                    fill="#fff"
                    stroke="none"
                    strokeWidth="2"
                    d="M8 9c-1.108 0-2 .892-2 2v8c0 1.108.892 2 2 2h12c1.108 0 2-.892 2-2v-8c0-1.108-.892-2-2-2H8zm5.95 1.5a3 3 0 01.05 0 3 3 0 013 3 3 3 0 01-1.75 2.727V19.5h-2.5v-3.273A3 3 0 0111 13.5a3 3 0 012.95-3z"
                    transform="scale(.26458)"
                ></path>
                <path
                    fill="none"
                    stroke="#fff"
                    strokeWidth="0.529"
                    d="M2.91 2.117v.529-1.323a.792.792 0 00-.793-.794H1.058a.792.792 0 00-.793.794V2.38"
                ></path>
            </g>
        </svg>
    );
};
